// extracted by mini-css-extract-plugin
module.exports = {"footerError":"Error_footerError__wKT2S"};